import React from 'react'

import { COLORS } from '../../constants'

type Props = {
  isUnloadActive: boolean
  isLoadActive: boolean
  /** バッジの枠・塗り色を直接指定 */
  color?: string
  /** 活性時の文字色 */
  activeTextColor?: string
  /** バッジボックスのpxサイズ（デフォルト: 20） */
  size?: number
}

export const LoadingAndUnLoadingBadge: React.FC<Props> = ({
  isUnloadActive,
  isLoadActive,
  color,
  activeTextColor = COLORS.white,
  size = 20,
}) => {
  const badgeColor = color ?? COLORS.blue
  const fontSize = Math.round(size * 0.6)

  const baseStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size,
    fontSize,
    fontWeight: 'bold',
    lineHeight: 1,
    border: `1px solid ${badgeColor}`,
    boxSizing: 'border-box',
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <div
        style={{
          ...baseStyle,
          borderRight: 'none',
          color: isUnloadActive ? activeTextColor : badgeColor,
          backgroundColor: isUnloadActive ? badgeColor : 'transparent',
          opacity: isUnloadActive ? 1 : 0.5,
        }}
      >
        卸
      </div>
      <div
        style={{
          width: 1,
          height: size,
          backgroundColor: badgeColor,
          flexShrink: 0,
          opacity: !isUnloadActive && !isLoadActive ? 0.5 : 1,
        }}
      />
      <div
        style={{
          ...baseStyle,
          borderLeft: 'none',
          color: isLoadActive ? activeTextColor : badgeColor,
          backgroundColor: isLoadActive ? badgeColor : 'transparent',
          opacity: isLoadActive ? 1 : 0.5,
        }}
      >
        積
      </div>
    </div>
  )
}
